import {
  Component,
  OnInit,
  ViewChild,
  OnChanges,
  Output,
  SimpleChanges,
  ElementRef,
  EventEmitter,
  AfterViewInit,
  Input,
  ChangeDetectorRef,
} from "@angular/core";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";
import { ChatLogService } from "../../../services/chatlog.service";
import { LogManifestService } from "../../../services/logmanifest.service";
import { TicketsService } from "../../../services/tickets.service";
import { ProcessingpService } from "../../../services/processing.service";
import { LocationService } from "../../../services/location.service";
import { NotificationService } from "../../../services/notification.service";
import { UserService } from "../../../services/user.service";
import { PrincipalinventoryService } from "../../../services/principalinventory.service";
import { MultiFilesService } from "../../../services/multifiles.service";
import { ChatLog } from "../../../models/chatLog";
import { Methods } from "../../methods";
import swal from "sweetalert2";
import { CommentsComponent } from "../../../shared/components/comments/comments.component";
import { Router } from "@angular/router";
import { DinamicData, Cell } from "../../../models/dinamic-data";
/*ATTRIBUTE MULTIPLE ITEMS*/
import { attributeMultipleItemsComponent } from "../../../shared/components/attribute-multiple-items/attribute-multiple-items.component";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { MatStepper } from "@angular/material/stepper";

declare const $: any;

@Component({
  selector: "app-batch",
  templateUrl: "./batch.component.html",
  styleUrls: ["./batch.component.css"],
  providers: [
    ChatLogService,
    LogManifestService,
    ProcessingpService,
    NotificationService,
  ],
})
export class BatchComponent implements OnInit, OnChanges {
  @ViewChild(CommentsComponent) child: CommentsComponent;
  @ViewChild(MatStepper) stepper!: MatStepper;

  @Input() disabled = false;

  public mtds: Methods = new Methods();

  public numberNotifications;
  public notificationsData;
  public chats: Array<ChatLog> = [];
  public identity;
  public token;
  public loading2 = false;
  public saving = false;
  public locationChanged = false;

  myWebSocket: WebSocketSubject<any> = webSocket(
    "wss://www.greenteksolutions.com/myws"
  );

  public loading;

  public errorContainers: boolean = false;
  public errorHardDrives: boolean = false;
  public errorAllInOne: boolean = false;
  public errorLaptops: boolean = false;
  public errorDesktops: boolean = false;
  public errorMobileDevices: boolean = false;
  public apikey = "";

  public itemManifestID = null;
  public hardDrives = 0;
  public mobileDevices = 0;
  public laptops = 0;
  public containers = 0;
  public containersmdl = 0;
  public desktops = 0;
  public allInOne = 0;
  public containersDevices = 0;
  public containersDevicesDone = 0;

  public hardDrivesSplit = 0;
  public hardDrivesDone = 0;
  public laptopsSplit = 0;
  public laptopsDone = 0;
  public containersSplit = 0;
  public desktopsSplit = 0;
  public desktopsDone = 0;
  public allInOneSplit = 0;
  public allInOneDone = 0;

  public batchPriorityLevel = "";

  public mobileDevicesSplit = 0;
  public mobileDevicesDone = 0;

  public containersDevicesSplit = 0;
  public saveSplit: boolean = false;
  public saveManifestB: boolean = false;
  public newWeightSplit: any = 0;

  public newManifest = false;
  public newManifest2 = false;
  public newManifest2_1step = false;
  public newManifest2_2step = false;
  public newManifest2_3step = false;
  public splitManifest = false;
  public newContainerType = "";
  public newContentType = "";
  public caddies = "";
  public newcontainerWeight = 0;
  public newcontainerTotalNetWeight = 0;
  public loadingLocationsNewContainer = false;
  public locationsListNewContainer = [];
  public newcontainerInternallocation_id = 0;
  public newcontainerNameInternal = "";
  public newcontainerLinkTo = "";
  public containers_newmanifest = [];
  public ssd = 0;
  public ssdDone = 0;
  public ssdSplit = 0;
  public itemsManifestNew: any[];
  public errorSsd: boolean = false;
  public item_split_status = "";
  public status_container_type = "";
  public idmanifestSelected: any;
  public newContainerType_split: any = "";
  public weightInputActivated: boolean = false;
  public assignInputActivated: boolean = true;

  public loadingUsers = false;
  public usersList: any[] = [];

  public total_chats: any = 0;

  public containersType = [
    { name: "Box", icon: "inventory" },
    { name: "Gaylord", icon: "inventory" },
    { name: "Gondola", icon: "inventory" },
    { name: "HDolly", icon: "inventory" },
    { name: "Pallet", icon: "pallet" },
    { name: "Rack", icon: "table_chart" },
    { name: "Standalone", icon: "mode_standby" },
  ];

  public contentType = [
    { name: "Devices", icon: "inventory" },
    { name: "HDD/SSD", icon: "inventory" },
    { name: "Mobile Devices", icon: "inventory" },
  ];
  public doa: number = 0;
  public passed: number = 0;
  public failed: number = 0;
  public noDrives: number = 0;
  public explanation: string = "";
  public showMarkCompletedForm: boolean = false;
  public message;
  public isWipe = false;

  optionsButtonSelect: {
    icon: string;
    iconColor: string;
    value: string;
    label: string;
  }[] = [
    {
      icon: "circle",
      iconColor: "rgb(244, 67, 54) !important",
      value: "Pending",
      label: "Pending",
    },
    {
      icon: "circle",
      iconColor: "rgb(255, 152, 0) !important",
      value: "In Progress",
      label: "In Progress",
    },
    {
      icon: "circle",
      iconColor: "rgb(76, 175, 80) !important",
      value: "Completed",
      label: "Completed",
    },
  ];

  /*public item = {
    typeOfContent: '',
    containerType: '',
    batch: '',
    status: '',
    id: '',
    laptopsDone: 0,
    desktopsDone: 0,
    allinoneDone: 0,
    ssdDone: 0,
    hardDrivesDone: 0,
    dosplit: 0,
    caddies: '',
    hardDrives: '',
    ssd: '',
    allInOne: '',
    desktops: '',
    laptops: '',
    internalLocation: null,

  }*/
  public numFiles = 0;
  public addFilesToBatch: boolean = false;
  public optionSelectMenuTrigger;

  public mouseOvered = false;
  public erasureMethod = "";
  public numChats = 0;
  private _item: any;
  originalItem: any; // Copia del objeto inicial
  @Input()
  set item(value: any) {
    this._item = value;
    if (value) {
      this.originalItem = JSON.parse(JSON.stringify(value)); // Crear copia original
    }
  }
  get item(): any {
    return this._item;
  }
  @Input() whs_id;
  @Input() showErasureMethod;

  @Output("getItemsManifest") getItemsManifest: EventEmitter<string> =
    new EventEmitter<string>();

  @Output("closeManifest") closeManifest: EventEmitter<string> =
    new EventEmitter<string>();
  @Output("recharge") recharge: EventEmitter<string> =
    new EventEmitter<string>();
  @Output() statusChanged = new EventEmitter<{ status: string }>();
  constructor(
    public router: Router,
    private _chatLogService: ChatLogService,
    private _logManifestService: LogManifestService,
    private _ticketsService: TicketsService,
    private _processingSerice: ProcessingpService,
    private _locationService: LocationService,
    private _notificationService: NotificationService,
    private _userService: UserService,
    private _inventoryService: PrincipalinventoryService,
    private uploadService: MultiFilesService,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef
  ) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.token = JSON.parse(localStorage.getItem("token"));
    this.apikey = this.identity.apiCompany;
    console.log(this.item, "este es mi item");
    this.newcontainerInternallocation_id = null;
  }

  get includesPI() {
    return this.router.url.includes("/processing-instructions");
  }
  confirmDeleteBatch(item) {
    let response = confirm("Are you sure you want to delete this batch?");

    if (response) {
      this.deletManiest_id = item.id;
      this.deleteManifest();
    }
  }
  resetStepper(): void {
    this.stepper.selectedIndex = 1;
  }
  getUsers() {
    this.loadingUsers = true;
    this._userService
      .getAllUsersLite(this._userService.getToken(), "exceptuser")
      .subscribe(
        (response) => {
          if (response.status === "success") {
            console.log(this.item);
            this.usersList = response.data.map((e) => {
              return { id: e.id, name: `${e.name} ${e.surname}` };
            });
          } else {
            alert("Error");
          }
          this.loadingUsers = false;
        },
        (error) => {
          this.loadingUsers = false;
          console.log(<any>error);
          alert("Error");
        }
      );
  }

  public deletManiest_id = null;
  showMarkCompleted(item, status) {
    console.log("sts", status);
    if (status == "Completed") {
      this.showMarkCompletedForm = true;
    } else {
      this.cancel();
      this.changestatusmanifest(item, status);
    }
  }
  public partDone = false;
  public type = "";
  showMarkDone(item, type) {
    this.partDone = true;
    this.showMarkCompletedForm = true;
    this.type = type;
  }
  cancel() {
    this.showMarkCompletedForm = false;
    this.passed = 0;
    this.failed = 0;
    this.doa = 0;
    this.noDrives = 0;
    this.explanation = "";
    this.message = "";
  }

  get sumDevices() {    

    if(this.type === 'HARDDRIVES')
      return this.item.hardDrives;
    else if(this.type === 'SSD')
      return this.item.ssd;
    else if(this.type === 'allInOne')
      return this.item.ssd;
    else if(this.type === 'DESKTOP')
      return this.item.desktops;
    else if(this.type === 'MOBILEDEVICES')
      return this.item.mobileDevices;
    else if(this.type === 'LAPTOP')
      return this.item.laptops;
    else{
      return (
        this.item.hardDrives +
        this.item.ssd +
        this.item.allInOne +
        this.item.desktops +
        this.item.mobileDevices +
        this.item.laptops
      );
    }
  }

  get sumForm() {
    return this.passed + this.failed + this.doa + this.noDrives;
  }
  get match() {
    return this.sumDevices === this.sumForm;
  }

  closeModal() {
    $("#markCompleted").on("hidden.bs.modal", () => {
      console.log("closeee");
    });
    $("#markCompleted").modal("hide");
  }
  get disabledForm() {
    return !this.explanation;
  }

  deleteManifest() {
    this._processingSerice
      .removeItemManifest(this.token, this.deletManiest_id)
      .subscribe((response) => {
        if (response.status === "success") {
          this.getItemsManifest.emit("done");
          this.closeManifest.emit("done");
          this.deletManiest_id = null;
        } else {
          alert(response.msg);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("ngOnChanges fired up! => ", this.item);
    console.log("showErasureMethod => ", this.showErasureMethod);
    this.cleanValues();
    this.locklocation(this.item.id);
    this.getInventories(this.item.id);
    // this.unlocklocation(this.item);
    $("div[class|='locationinput']").show();
    $("div[class|='locationselect']").hide();
    this.laptopsSplit = 0;
    this.desktopsSplit = 0;
    this.ssdSplit = 0;
    this.allInOneSplit = 0;
    this.hardDrivesSplit = 0;
    this.weightInputActivated = false;
    this.assignInputActivated = true;
    this.getUsers();
    if (changes["item"] && changes["item"].currentValue) {
      this.originalItem = JSON.parse(JSON.stringify(this.item)); // Crear copia profunda
    }
  }

  ngOnInit() {
    console.log(this.item, "item aqui");
    this.optionSelectMenuTrigger = this.item.status;

    console.log("holis");

    this.getLocationsContainerToEdit(this.item);

    console.log(this.item.id);

    this.uploadService
      .getFiles(this.token, this.item.id, "FILESBATCH")
      .subscribe((r2) => {
        if (r2.code === 400 && r2.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this.router.navigate(["/pages/lock"]);
        } else if (r2.status == "success") {
          this.numFiles = r2.data.length;
        }
      });
  }

  total_chats_func(e) {
    this.total_chats = e;
  }
  public priorityBatch;

  get priorityLevel() {
    switch (this.item.processingInstruction.poPriorityLevel) {
      case "LOWPRIORITY":
        return (this.priorityBatch = "Low");
      case "MEDIUMPRIORITY":
        return (this.priorityBatch = "Medium");
      case "FASTPRIORITY":
        return (this.priorityBatch = "Fast");
      case "URGENTPRIORITY":
        return (this.priorityBatch = "Urgent Same Day");
      default:
        return this.priorityBatch;
    }
  }

  changeLocationEditContainer(location, item) {
    // console.log("location", location);
    this._processingSerice
      .changeLocationManifest(this.token, item.id, { id_location: location.id })
      .subscribe((response) => {
        if (response.status === "success") {
          this.showToast(
            "success",
            `Location has been changed successfully.`,
            2000
          );

          item.internalLocation = response.data.internalLocation;
          // console.log("itemid", item.id);
          this.locklocation(item.id);
        }
      });
  }  

  public newLocationInSplit: any = "";
  changeLocationNewContainerSplit(location) {
    this.newLocationInSplit = location.id;
  }

  unlockWeight(item) {
    $("#inputWeight" + item.id).prop("disabled", false);
    this.weightInputActivated = true;
  }
  onAssignToChange(selectedValue: any): void {
    this.item.assignTo = selectedValue.id; // Actualiza el valor
    console.log("Updated assignTo:", this.item.assignTo);
  }
  resetItem(type): void {
    if (type == "weight") {
      this.weightInputActivated = false;
    } else {
      this.assignInputActivated = true;
      this.getUsers();
    }
    this.item = JSON.parse(JSON.stringify(this.originalItem)); // Restaurar copia original
  }
  syncOriginalItem(): void {
    this.originalItem = JSON.parse(JSON.stringify(this.item));
  }
  lockWeight(item) {
    $("#inputWeight" + item.id).prop("disabled", true);
    this.weightInputActivated = false;

    this._processingSerice
      .changeweightManifest(this.token, item.id, { weight: item.weight })
      .subscribe(
        (response) => {
          if (response.code === 200) {
            // this.item = response.data;
            this.showToast(
              "success",
              `Weight has been changed successfully.`,
              2000
            );
            this.syncOriginalItem();
          } else {
            this.mtds.notifyError(response.msg, response.code);
          }
        },
        (error) => {
          this.mtds.notifyError(error.statusText);
        }
      );
  }

  unlockAssign(item) {
    this.assignInputActivated = false;
  }

  lockAssign(item) {
    this.assignInputActivated = true;

    this._processingSerice
      .editItemManifest(this.token, item.id, item)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.code === 200) {
            this.showToast(
              "success",
              `The assigned user has been changed successfully.`,
              2000
            );

            // this.item = response.data;
          } else {
            this.mtds.notifyError(response.msg, response.code);
          }
        },
        (error) => {
          this.mtds.notifyError(error.statusText);
        }
      );
  }

  saveSplitManifest() {
    this.itemManifestID = this.item.id;

    this.errorHardDrives = false;
    this.errorAllInOne = false;
    this.errorDesktops = false;
    this.errorLaptops = false;
    this.errorSsd = false;
    this.errorMobileDevices = false;

    this.saveSplit = true;

    let granted = true;

    if (this.item_split_status && this.item_split_status.length > 2) {
      if (this.status_container_type == "HDD/SSD") {
        if (this.hardDrivesDone === 0 || this.hardDrivesDone === null) {
          this.hardDrivesDone = 0;

          if (Number(this.hardDrives) - Number(this.hardDrivesSplit) < 0)
            this.errorHardDrives = true;
        }

        if (this.ssdDone === 0 || this.ssdDone === null) {
          this.ssdDone = 0;
          if (Number(this.ssd) - Number(this.ssdSplit) < 0)
            this.errorSsd = true;
        }

        if (this.errorHardDrives || this.errorSsd) granted = false;
      }

      if (this.status_container_type == "Devices") {
        if (this.laptopsDone === 0 || this.laptopsDone === null) {
          this.laptopsDone = 0;
          if (Number(this.laptops) - Number(this.laptopsSplit) < 0)
            this.errorLaptops = true;
        }

        if (this.desktopsDone === 0 || this.desktopsDone === null) {
          this.desktopsDone = 0;
          if (Number(this.desktops) - Number(this.desktopsSplit) < 0)
            this.errorDesktops = true;
        }
        if (this.allInOneDone === 0 || this.allInOneDone === null) {
          this.allInOneDone = 0;
          if (Number(this.allInOne) - Number(this.allInOneSplit) < 0)
            this.errorAllInOne = true;
        }

        if (this.errorLaptops || this.errorDesktops || this.errorAllInOne)
          granted = false;
      }

      if (this.status_container_type == "MobileDevices") {
        if (this.mobileDevicesDone === 0 || this.mobileDevicesDone === null) {
          this.mobileDevicesDone = 0;
          if (Number(this.mobileDevices) - Number(this.mobileDevicesSplit) < 0)
            this.errorMobileDevices = true;
        }

        if (this.errorMobileDevices) granted = false;
      }
    } else {
      if (this.hardDrivesDone === 0 || this.hardDrivesDone === null) {
        this.hardDrivesDone = 0;
        if (Number(this.hardDrives) - Number(this.hardDrivesSplit) < 0)
          this.errorHardDrives = true;
      }

      if (this.ssdDone === 0 || this.ssdDone === null) {
        this.ssdDone = 0;
        if (Number(this.ssd) - Number(this.ssdSplit) < 0) this.errorSsd = true;
      }

      if (this.laptopsDone === 0 || this.laptopsDone === null) {
        this.laptopsDone = 0;
        if (Number(this.laptops) - Number(this.laptopsSplit) < 0)
          this.errorLaptops = true;
      }

      if (this.desktopsDone === 0 || this.desktopsDone === null) {
        this.desktopsDone = 0;
        if (Number(this.desktops) - Number(this.desktopsSplit) < 0)
          this.errorDesktops = true;
      }
      if (this.allInOneDone === 0 || this.allInOneDone === null) {
        this.allInOneDone = 0;
        if (Number(this.allInOne) - Number(this.allInOneSplit) < 0)
          this.errorAllInOne = true;
      }

      if (
        this.errorLaptops ||
        this.errorDesktops ||
        this.errorAllInOne ||
        this.errorSsd
      )
        granted = false;
    }

    if (granted) {
      let data: any;
      data = {
        hardDrivesSplit: this.hardDrivesSplit,
        laptopsSplit: this.laptopsSplit,
        containersSplit: this.containersSplit,
        processing_instruction_id: this.item.processingInstruction.id,
        allInOneSplit: this.allInOneSplit,
        desktopsSplit: this.desktopsSplit,
        containersDevicesSplit: this.containersDevicesSplit,
        ssdSplit: this.ssdSplit,
        mobileDevicesSplit: this.mobileDevicesSplit,
        newWeightSplit: this.newWeightSplit,
        newLocationInSplit: this.newLocationInSplit,
        newContainerType_split: this.newContainerType_split,
      };

      this._processingSerice
        .newItemSplitManifest(this.token, this.itemManifestID, data)
        .subscribe((response) => {
          if (response.status === "success") {
            swal.fire({
              title: "Batch container has been successfully splited",
              text: "",
              buttonsStyling: false,
              customClass: {
                confirmButton: "btn btn-success",
              },
            });

            let batch;

            batch = response.data.batch;

            if (this.hardDrivesSplit != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.item.id,
                type: "HD-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                batch: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            if (this.laptopsSplit != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.item.id,
                type: "LP-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                batch: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            if (this.allInOneSplit != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.item.id,
                type: "ALL-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                batch: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            if (this.desktopsSplit != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.item.id,
                type: "DK-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                batch: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            this._processingSerice
              .getSingleManifest(this.token, this.item.id)
              .subscribe(
                (response) => {
                  if (
                    response.code === 400 &&
                    response.msg === "Authorization not valid"
                  ) {
                    this.mtds.notifyError("Your session has expired");
                    localStorage.clear();
                    //this._router.navigate(['/pages/lock']);
                  } else if (response.code === 200) {
                    this.item = response.data;

                    this.item.dosplit = false;
                  } else {
                    this.mtds.notifyError(response.msg, response.code);
                  }
                },
                (error) => {
                  this.mtds.notifyError(error.statusText);
                }
              );

            //this.getItemsManifest();
            this.getItemsManifest.emit("done");
            //this.closeManifest();
            this.closeManifest.emit("done");
          }
        });
    }
  }

  printItemManifest(id) {
    console.log(id);
    window.open(
      "https://www.greenteksolutionsllc.com/backend/reports/wipe-room-form.php?id=" +
        id.id +
        "&batch=" +
        id.batch +
        "&apikey=" +
        this.apikey
    );
  }
  public editLoc = false;

  unlocklocation(item) {
    this.editLoc = true;
    console.log("item => ", item);

    this.getLocationsContainerToEdit(item);
    $(".locationinput-" + item.id).hide();
    $(".locationselect-" + item.id).show();
  }

  public showAllLocations: boolean = false;

  onCheckboxChange(event) {
    if (event.checked) this.showAllLocations = true;
    else this.showAllLocations = false;

    this.getLocationsContainerToEdit(this.item);
  }

  getLocationsContainerToEdit(item) {
    this.locationsListNewContainer = [];

    let whs = item.internalLocation.location.id;

    this.loadingLocationsNewContainer = true;
    let json;
    json = {
      item: item.typeOfContent,
      totalNetWeight: item.weight,
      po: item.processingInstruction.po.po,
      showAllLocations: this.showAllLocations,
      whs: whs,
    };

    this._locationService
      .getAvailables(this.token, this.whs_id, json)
      .subscribe(
        (response) => {
          this.loadingLocationsNewContainer = false;
          if (response.status === "success") {
            this.locationsListNewContainer = response.data.map((item) => {
              // console.log(item);
              return {
                id: item.id,
                name: `${item.location.name} - ${item.locationName}: ${item.locationRow}-${item.locationBay}-${item.locationLevel}-${item.locationSection}`,
                linkTo: item.linkTo,
              };
            });

            const flat = this.locationsListNewContainer.find(
              (item) => item.id === this.newcontainerInternallocation_id
            );

            if (!flat && this.newcontainerInternallocation_id !== null) {
              const location = {
                id: this.newcontainerInternallocation_id,
                name: this.newcontainerNameInternal,
                linkTo: this.newcontainerLinkTo,
              };
              this.locationsListNewContainer.push(location);
            }
          }
          this.loading = false;
        },
        (error) => {
          this.loadingLocationsNewContainer = false;
          console.log(<any>error);
          // this.showSwal('error');
        }
      );
  }

  locklocation(id) {
    this.editLoc = false;
    console.log("locklocation fired");
    $(".locationinput-" + id).show();
    $(".locationselect-" + id).hide();
  }

  get val() {
    return ` ${this.item.internalLocation.location.name} - ${this.item.internalLocation.locationName}: ${this.item.internalLocation.locationRow}-${this.item.internalLocation.locationBay}-${this.item.internalLocation.locationLevel}-${this.item.internalLocation.locationSection}`;
  }

  handleChange(e) {
    console.log(e, "event");
  }

  public tmpItem: any;
  public tmpTypeItem: any;
  public tmpNumFiles: any;
  public tmpStatus: any;
  public tmpType: any;
  public hasFile: string = 'No';

  public preSetManifestDone(item, typeItem){
    this.tmpNumFiles = this.numFiles;
    this.tmpItem = item;
    this.tmpTypeItem = typeItem;
    this.tmpType = 'manifestDone';

    if(this.passed > 0 || this.failed > 0){
      this.addFilesToBatch = true;
    } else {
      this.setManifestDone(item, typeItem);
    }
  }

  viewFiles(){
    if(this.tmpNumFiles < this.numFiles && this.tmpType === 'manifestDone'){
      this.hasFile = 'Yes';
      this.setManifestDone(this.tmpItem, this.tmpTypeItem);  
    }else if(this.tmpNumFiles < this.numFiles && this.tmpType === 'statusManifest'){
      this.hasFile = 'Yes';
      this.changestatusmanifest(this.tmpItem, this.tmpStatus);
    }
  }

  public preChangestatusmanifest(item, status){
    this.tmpNumFiles = this.numFiles;
    this.tmpItem = item;
    this.tmpStatus = status;
    this.tmpType = 'statusManifest';

    if(this.passed > 0 || this.failed > 0){
      this.addFilesToBatch = true;
    } else {
      this.changestatusmanifest(item, status);
    }
  }


  setManifestDone(item, typeItem) {
    console.log("sedispara");
    console.log(item.status, "sttat");
    this.loadingChats = true;
    if (typeItem === "SSD") {
      item.processingSSD = true;
    } else if (typeItem === "HARDDRIVES") {
      item.processingHDD = true;
    } else if (typeItem === "AIO") {
      item.processingAIO = true;
    } else if (typeItem === "DESKTOP") {
      item.processingDESKTOP = true;
    } else if (typeItem === "LAPTOP") {
      item.processingLAPTOP = true;
    } else if (typeItem === "MOBILEDEVICES") {
      item.processingMOBILEDEVICES = true;
    }
    // if (this.item.status !== 'Completed') {
    // }
    this._processingSerice
      .setmanifestdone(this.token, item.id, { typeItem: typeItem, hasFile: this.hasFile })
      .subscribe((response) => {
        console.log("setManifestDone => response", response);
        if (response.code == 200 && response.status == "success") {
          this.loadingChats = false;
          if (typeItem === "SSD") {
            item.ssdDone = 1;
            item.processingSSD = false;
          } else if (typeItem === "HARDDRIVES") {
            item.hardDrivesDone = 1;
            item.processingHDD = false;
          } else if (typeItem === "AIO") {
            item.allinoneDone = 1;
            item.processingAIO = false;
          } else if (typeItem === "DESKTOP") {
            item.desktopsDone = 1;
            item.processingDESKTOP = false;
          } else if (typeItem === "LAPTOP") {
            item.laptopsDone = 1;
            item.processingLAPTOP = false;
          } else if (typeItem === "MOBILEDEVICES") {
            item.mobileDevicesDone = 1;
            item.processingMOBILEDEVICES = false;
          }

          if (item.containerType === "HDD/SSD") {
            if (
              response.data.hardDrivesDone === 1 &&
              response.data.ssdDone === 1
            ) {
              this.changestatusmanifest(item, "Completed");
              return; // Evita que se ejecute el código posterior
            }
          } else if (item.containerType === "Devices") {
            if (
              response.data.allinoneDone === 1 &&
              response.data.desktopsDone === 1 &&
              response.data.laptopsDone === 1
            ) {
              this.changestatusmanifest(item, "Completed");
              return; // Evita que se ejecute el código posterior
            }
          } else if (item.containerType === "Mobile Devices") {
            if (response.data.mobileDevicesDone === 1) {
              this.changestatusmanifest(item, "Completed");
              return; // Evita que se ejecute el código posterior
            }
          }

          // Si ninguna de las condiciones anteriores se cumple, ejecuta esto
          if (item.status !== "Completed") {
            this.changestatusmanifest(item, "In Progress");
          }
        } else {
          // manejar el error y resetear el estado de procesamiento
          if (typeItem === "SSD") {
            item.processingSSD = false;
          } else if (typeItem === "HARDDRIVES") {
            item.processingHDD = false;
          } else if (typeItem === "AIO") {
            item.processingAIO = false;
          } else if (typeItem === "DESKTOP") {
            item.processingDESKTOP = false;
          } else if (typeItem === "LAPTOP") {
            item.processingLAPTOP = false;
          } else if (typeItem === "MOBILEDEVICES") {
            item.processingMOBILEDEVICES = false;
          }
        }
      });
  }

  getTypeName(type: string): string {
    switch (type) {
      case "SSD":
        return "SDD";
      case "HARDDRIVES":
        return "HDD";
      case "AIO":
        return "AIO";
      case "DESKTOP":
        return "Desktop";
      case "LAPTOP":
        return "Laptop";
      case "MOBILEDEVICES":
        return "Mobile Devices";
      default:
        return type;
    }
  }

  public loadingChats = false;
  changestatusmanifest(item, status) {
    console.log("ME DISPARO");
    this.loadingChats = true;
    let statusBefore = this.item.status;

    let whs_id = this.item.internalLocation
      ? this.item.internalLocation.location
        ? this.item.internalLocation.location.id
        : 0
      : 0;

    this._processingSerice
      .changestatusmanifest(this.token, item.id, { status: status, hasFile: this.hasFile })
      .subscribe((response) => {
        if (response.code == 200 && response.status == "success") {
          this.showToast(
            "success",
            `Status has been changed to ${status}`,
            2000
          );

          console.log("changestatusmanifest => response", response);
          // this.showCommentsBatch(item.id);
          this.recharge.emit();
          item.status = status;
          this.showMarkCompletedForm = false;
          this.statusChanged.emit({ status: status });
          if (
            statusBefore == "Pending" &&
            this.item.status == "In Progress" &&
            this.item.internalLocation.locationName !== "Wipe Room"
          ) {
            this.isWipe = true;
            this.recharge.emit();

            if (whs_id === 3) whs_id = 825;
            else if (whs_id === 243) whs_id = 1453;

            this.changeLocationEditContainer(
              { id: whs_id, linkTo: "INTESTING", name: "Wipe Room: 0-0-0-0" },
              item
            );
            this.locationChanged = true;
            setTimeout(() => {
              this.locationChanged = false;
            }, 1500);
          }

          if (
            (status == "In Progress" && this.partDone) ||
            status == "Completed"
          ) {
            if (this.explanation) {
              if (this.item.containerType == "Devices") {
                this.message = `  
                Batch Number # ${this.item.batch}
                Batch ID # ${this.item.id}
                 ${this.type ? `Type: ${this.getTypeName(this.type)}` : ""}

                How many devices passed erasure? - ${this.passed}
                How many devices Failed erasure? - ${this.failed}
                How many devices had DOA drives? - ${this.doa}
                How many devices didn't have drives? - ${this.noDrives}

                Explanation: ${this.explanation}`;
              } else {
                this.message = `
              Batch Number # ${this.item.batch}
              Batch ID # ${this.item.id} 
                 ${this.type ? `Type: ${this.getTypeName(this.type)}` : ""}

              How many passed erasure? - ${this.passed}
              How many failed erasure? - ${this.failed}
              How many were DOA? - ${this.doa}
              
              Explanation: ${this.explanation}
              `;
              }
            } else {
              if (this.item.containerType == "Devices") {
                this.message = `
                Batch Number # ${this.item.batch}
                Batch ID # ${this.item.id} 
                 ${this.type ? `Type: ${this.getTypeName(this.type)}` : ""}

                How many devices passed erasure? - ${this.passed}
                How many devices failed erasure? - ${this.failed}
                How many devices had DOA drives? - ${this.doa}
                How many devices didn't have drives? - ${this.noDrives} `;
              } else {
                this.message = `
                Batch Number # ${this.item.batch}
                Batch ID # ${this.item.id} 
                 ${this.type ? `Type: ${this.getTypeName(this.type)}` : ""}

              How many passed erasure? - ${this.passed}
              How many failed erasure? - ${this.failed}
              How many were DOA? - ${this.doa}
              `;
              }
            }
          }
          this.loadingChats = false;

          console.log(status, "comming", statusBefore, "before");
          if (
            (status == "Pending" && statusBefore == "Completed") ||
            (status == "In Progress" && statusBefore == "Completed")
          ) {
            this.message = `Change Status to ${status}`;
            this.child.sendMessage(this.message);
            console.log("loaad", this.loadingChats);
            console.log(this.message, "message");
          }
          this.passed = 0;
          this.failed = 0;
          this.doa = 0;
          this.noDrives = 0;
          this.explanation = "";
          // this.noMatch = false;
        }
      });
  }

  showCommentsBatch(id) {
    $(".commentbox-" + id).toggle();
    this.viewMessage("BATCH", id);
  }
  viewMessage(type, id) {
    let json = {
      type: type,
    };
    this._chatLogService.viewMessage(this.token, id, json).subscribe(
      (response) => {
        if (response.status != "success") {
          console.log("response", response);
        } else {
          console.log("response success", response);
        }
      },
      (error) => {
        console.log(<any>error);
        this.saving = false;
        this.mtds.notifyError("error");
      }
    );
  }

  changeNewContainerType() {}

  onTabChange(event: MatTabChangeEvent): void {
    const splitTabIndex = 2; // Cambia según el índice de la pestaña 'Split Batch'
    const infoTabIndex = 0; // Cambia según el índice de la pestaña 'Split Batch'
    if (event.index === splitTabIndex) {
      this.splitItemNew(this.item);
    }
    if (event.index === infoTabIndex) {
      this.item.dosplit = false;
    } else {
      this.showMarkCompletedForm = false;
    }
  }

  splitItemNew(item) {
    this.getLocationsContainerToEdit(item);

    console.log("item => ", item);
    this.itemManifestID = item.id;
    this.hardDrivesDone = item.hardDrivesDone;
    this.laptopsDone = item.laptopsDone;
    this.allInOneDone = item.allinoneDone;
    this.newContainerType_split = item.typeOfContent;

    this.containersDevicesDone = item.containersDevicesDone;
    this.containersDevices = item.containersDevices;

    this.desktopsDone = item.desktopsDone;
    this.hardDrives = item.hardDrives;
    this.laptops = item.laptops;
    this.allInOne = item.allInOne;
    this.desktops = item.desktops;
    this.batchPriorityLevel = item.batchPriorityLevel;
    this.ssd = item.ssd;
    this.ssdDone = item.ssdDone;
    item.dosplit = true;
    this.item_split_status = item.status ? item.status : "";
    this.errorHardDrives = false;
    this.errorLaptops = false;
    this.errorAllInOne = false;
    this.errorDesktops = false;
    this.saveSplit = false;
    this.status_container_type = item.containerType;
    this.newcontainerInternallocation_id = item.internalLocation.id
      ? item.internalLocation.id
      : "";
    this.newLocationInSplit = item.internalLocation.id
      ? item.internalLocation.id
      : "";
    console.log(
      "this.newcontainerInternallocation_id => ",
      this.newcontainerInternallocation_id
    );
    console.log(
      "locationsListNewContainer => ",
      this.locationsListNewContainer
    );
  }

  /*NUEVA SECCIÓN DE AGREGAR ITEMS*/

  public nuevo = {
    type: "iqid",
    value: "",
    value_two: "",
    change: 0,
  };

  public itemsID: Array<any> = [];
  public itemsAdd: Array<any> = [];
  public containerAlreadyExist = false;
  public confirmMove = false;
  public saveConfirmMove = false;
  public itemID;
  public savingItem = false;

  onEnter(event: KeyboardEvent): void {
    if (event.key === "Enter") {
      //Almacenar el contenido del textarea en un array, separando por saltos de línea
      const linesArray = this.nuevo.value.split("\n");

      // Obtener el último elemento del array
      const lastLine = linesArray[linesArray.length - 1];

      // Verificar si el último elemento ya existe en el array
      const isLastLineRepeated =
        linesArray.indexOf(lastLine) !== linesArray.length - 1;

      console.log("Array of lines:", linesArray);
      console.log("Last line:", lastLine);
      console.log("Is last line repeated:", isLastLineRepeated);

      if (isLastLineRepeated) {
        alert(lastLine + " is repeated!");

        // Se eliminar último elemento agregado
        linesArray.splice(linesArray.length - 1, 1);

        // Unir los elementos del array de nuevo en una cadena
        this.nuevo.value = linesArray.join("\n");
      }
    }
  }

  removeItemFromArray(id) {
    this.itemsID = this.itemsID.filter((item) => item.id_inventory !== id);
    //this.checkItemsNotFound();

    // Dividir la cadena en un array utilizando el salto de línea como separador
    let idsArray = this.nuevo.value.split(/\s+/);

    // Encontrar el índice del ID a eliminar
    let indexToRemove = idsArray.indexOf(id);

    // Si se encuentra el ID a eliminar, eliminarlo del array
    if (indexToRemove !== -1) {
      idsArray.splice(indexToRemove, 1);
    }

    // Unir los elementos del array de nuevo en una cadena
    this.nuevo.value = idsArray.join("\n");
  }

  removeItemFromArrayAdd(id) {
    this.itemsAdd = this.itemsAdd.filter((item) => item.id_inventory !== id);
  }

  cleanValues() {
    //this.containerAlreadyExist = false;
    this.itemID = 0;
    this.nuevo.value_two = "";
    this.confirmMove = false;
    this.itemsID = [];
    this.itemsAdd = [];
    this.nuevo.value = "";
    this.showInventories = false;
  }

  saveItem() {
    //this.containerAlreadyExist = false;

    let json = {
      type: this.nuevo.type,
      value: this.nuevo.value,
      items: this.itemsID,
    };

    console.log(json);

    this.savingItem = true;
    this._inventoryService.createForBatch(this.item.id, json).subscribe(
      (r) => {
        console.log(r);
        if (r.code === 200) {
          //this.containerAlreadyExist = true;

          this.itemsID = [];
          this.itemsID = r.itemID;
          console.log(this.itemsID, "iddd");

          if (this.itemsAdd.length === 0 && r.itemsAdd)
            this.itemsAdd = r.itemsAdd;
          else if (this.itemsAdd.length !== 0 && r.itemsAdd) {
            this.itemsAdd = this.itemsAdd.concat(r.itemsAdd);
            this.ref.detectChanges();
          }

          this.nuevo.value = r.itemsCheck;
          this.getInventories(this.item.id, true, true);
          //this.checkItemsNotFound();
        } else {
          this.mtds.notifyError(r.msg);
        }
        this.savingItem = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.savingItem = false;
      }
    );
  }

  public loadingInventories = false;

  public campoBusqueda = "";
  public paginaActual = 1;
  public itemsPorPagina = "10";
  public totalItems = 0;
  public totalPaginas = 1;

  public filtros = [];
  public showInventories: boolean = false;

  public inventories: DinamicData = new DinamicData([
    "check",
    "Id",
    "Mfgr",
    "Item",
    "Serial#",
    "Condition",
    "Status",
    "Actions",
  ]);

  /*ITEMS EN LA TABLA*/
  public bulk: Array<number> = [];
  public massiveBulk: Array<number> = [];

  public bulk_cant = 0;
  public massive = false;

  getInventories(e = null, newfilter = true, additems = false) {
    if (this.item.id !== undefined) {
      this.loadingInventories = true;
      this._inventoryService
        .showByBatch(
          this.item.id,
          e !== null ? e.page : 1,
          e !== null ? e.perPage : 10,
          e !== null
            ? (this.campoBusqueda = e.search)
            : (this.campoBusqueda = ""),
          this.filtros
        )
        .subscribe(
          (r) => {
            console.log(r);
            if (r.code === 400 && r.msg === "Authorization not valid") {
              this.mtds.notifyError("Your session has expired");
              localStorage.clear();
              this.router.navigate(["/pages/lock"]);
            } else if (r.status === "success") {
              this.paginaActual = Number(r.page_actual);
              this.itemsPorPagina = String(r.items_per_page);
              this.totalItems = Number(r.total_items_count);
              this.totalPaginas = Number(r.total_pages);

              if (newfilter) {
                this.filtros = [
                  null,
                  {
                    key: "filter_id",
                    title: "Id",
                    value: "",
                    type: "contains",
                    key_type: "filter_id_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_mfgr",
                    title: "Mfgr",
                    value: "",
                    type: "contains",
                    key_type: "filter_mfgr_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_item",
                    title: "Item",
                    value: "",
                    type: "contains",
                    key_type: "filter_item_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_serial",
                    title: "Serial",
                    value: "",
                    type: "equalto",
                    key_type: "filter_serial_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_condition",
                    title: "Condition",
                    value: "",
                    type: "startswith",
                    key_type: "filter_condition_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_status",
                    title: "Status",
                    value: "",
                    type: "equalto",
                    key_type: "filter_status_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  null,
                ];
              }

              /*if(this.totalItems > 0){
              this.showInventories = true;
              this.ref.detectChanges();
            } else if (additems) {
              this.showInventories = false;
              this.ref.detectChanges();
            } else if (this.totalItems === 0 && !newfilter){
              this.showInventories = true;
              this.ref.detectChanges();
            } else if (this.totalItems === 0 && newfilter){
              this.showInventories = false;
              this.ref.detectChanges();
            }*/
              if (this.totalItems > 0) this.showInventories = true;

              let actionButtons;

              actionButtons = [
                { icon: "remove_red_eye", action: "Detail", color: "info" },
                { icon: "logout", action: "Remove", color: "danger" },
              ];

              this.inventories.rows = [];
              for (const element of r.data) {
                let selected_value = false;

                if (this.bulk.includes(element.id.toString()))
                  selected_value = true;

                this.massiveBulk.push(element.id);

                this.inventories.rows.push([
                  new Cell(element.id, {
                    type: "checkbox",
                    selected: selected_value,
                  }), // Check box
                  new Cell(element.id),
                  new Cell(element.mfgr),
                  new Cell(element.item),
                  new Cell(element.serialnumber),
                  new Cell(element.conditioninventory),
                  new Cell(element.status, {
                    class: "fw-bold",
                    color: element.status === "Available" ? "green" : "orange",
                  }),
                  new Cell(actionButtons, { type: "actions" }),
                ]);
              }
            } else {
              this.mtds.notifyError(r.msg, r.code);
            }
            this.loadingInventories = false;
          },
          (error) => {
            this.loadingInventories = false;
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
    }
  }

  reportWithAttributes() {
    let bulk;

    if (this.bulk.length > 0) bulk = this.bulk;
    else bulk = this.massiveBulk;

    const json = {
      apikey: this.apikey,
      data: bulk,
    };

    this._inventoryService.reportWithAttributes(json).subscribe(
      (response) => {
        //console.log(response);
        if (response._body) {
          let body = JSON.parse(response._body);
          this.mtds.notifyError(body.error);
        } else {
          const url = response.headers.get("Content-Disposition").split("=");
          window.open(url[1]);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  reportWithAttributesExtreme() {
    let bulk;

    if (this.bulk.length > 0) bulk = this.bulk;
    else bulk = this.massiveBulk;

    const json = {
      apikey: this.apikey,
      data: bulk,
    };

    this._inventoryService.reportWithAttributesExtreme(json).subscribe(
      (response) => {
        //console.log(response);
        if (response._body) {
          let body = JSON.parse(response._body);
          this.mtds.notifyError(body.error);
        } else {
          const url = response.headers.get("Content-Disposition").split("=");
          window.open(url[1]);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  attributeMultipleItems() {
    let bulk;

    if (this.bulk.length > 0) bulk = this.bulk;
    else bulk = this.massiveBulk;

    let dialogRef = this.dialog.open(attributeMultipleItemsComponent, {
      width: "90%",
      data: bulk,
      disableClose: true,
      autoFocus: false,
      maxHeight: "90vh", //you can adjust the value as per your view
    });

    dialogRef.afterClosed().subscribe((result) => {
      //this.getData();
    });
  }

  vaciarContainer(id) {
    if (this.bulk.length === 0) this.dropContainer(id);
    else {
      swal
        .fire({
          title: `Are you sure you want to remove this item from this batch ${this.item.id}?`,
          showCancelButton: true,
          buttonsStyling: false,
          customClass: {
            cancelButton: "order-1 btn btn-danger",
            confirmButton: "order-2 btn btn-success",
          },
          confirmButtonColor: "#4CAF50",
          confirmButtonText: "Yes, Remove",
          icon: "info",
          iconColor: "#C19A0A",
        })
        .then(
          function (result) {
            if (result.value) {
              this.removeItemsContainer();
            }
          }.bind(this)
        );
    }
  }

  removeItemsContainer() {
    //($("#modalRemoveItems") as any).modal("hide");

    let json = {
      bulk: this.bulk,
    };

    this._ticketsService.removeBulkItemBatch(this.item.id, json).subscribe(
      (r) => {
        console.log(r);
        if (r.code === 200) {
          swal.fire({
            title: "Item(s) has been removed successfully",
            text: "",
            buttonsStyling: false,

            customClass: {
              confirmButton: "btn btn-success",
            },
            icon: "success",
          });

          this.bulk = [];
          this.getInventories();
        } else {
          this.mtds.notifyError(r.msg);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }

  dropContainer(id) {
    swal
      .fire({
        title: "Are you sure you want to empty this batch?",
        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          cancelButton: "order-1 btn btn-danger",
          confirmButton: "order-2 btn btn-success",
        },
        confirmButtonColor: "#4CAF50",
        confirmButtonText: "Yes, empty it",
        icon: "info",
        iconColor: "#C19A0A",
      })
      .then(
        function (result) {
          if (result.value) {
            this._ticketsService.dropBatch(id).subscribe(
              (r) => {
                console.log(r);
                if (r.code === 200) {
                  swal.fire({
                    title: "Batch has been empty successfully",
                    text: "",
                    buttonsStyling: false,

                    customClass: {
                      confirmButton: "btn btn-success",
                    },
                    icon: "success",
                  });

                  this.getInventories();
                } else {
                  this.mtds.notifyError(r.msg);
                }
              },
              (error) => {
                this.mtds.notifyError(error.statusText, error.status);
              }
            );
          }
        }.bind(this)
      );
  }

  actions(e) {
    switch (e.action) {
      case "Detail":
        window.open(`/inventory/product/${e.id}`);
        break;

      case "Remove":
        swal
          .fire({
            title: `Are you sure you want to remove this item from this batch ${this.item.id}?`,
            showCancelButton: true,
            buttonsStyling: false,
            customClass: {
              cancelButton: "order-1 btn btn-danger",
              confirmButton: "order-2 btn btn-success",
            },
            confirmButtonColor: "#4CAF50",
            confirmButtonText: "Yes, Remove",
            icon: "info",
            iconColor: "#C19A0A",
          })
          .then(
            function (result) {
              if (result.value) {
                let json = {
                  container_id: this.item.id,
                };

                this._ticketsService.removeItemBatch(e.id, json).subscribe(
                  (r) => {
                    console.log(r);
                    if (r.code === 200) {
                      swal.fire({
                        title: "Item(s) has been removed successfully",
                        text: "",
                        buttonsStyling: false,

                        customClass: {
                          confirmButton: "btn btn-success",
                        },
                        icon: "success",
                      });

                      this.removeItemFromArrayAdd(e.id);

                      this.getInventories();
                    } else {
                      this.mtds.notifyError(r.msg);
                    }
                  },
                  (error) => {
                    this.mtds.notifyError(error.statusText, error.status);
                  }
                );
              }
            }.bind(this)
          );

        break;
    }
  }
}
